export type LegalTextPart =
  { kind: "text"; text: string } | { kind: "link"; label: string; href: string; internal: boolean };

const LINK = /\[([^\]]+)\]\(([^)\s]+)\)/g;

/**
 * Splits legal copy into plain text and `[label](href)` links. Internal paths
 * ("/privacy") are rendered as localized router links, everything else
 * (mailto:, https:) as a plain anchor.
 */
export function splitLegalLinks(text: string): LegalTextPart[] {
  const parts: LegalTextPart[] = [];
  let last = 0;
  for (const match of text.matchAll(LINK)) {
    const start = match.index ?? 0;
    if (start > last) parts.push({ kind: "text", text: text.slice(last, start) });
    const href = match[2];
    parts.push({ kind: "link", label: match[1], href, internal: href.startsWith("/") });
    last = start + match[0].length;
  }
  if (last < text.length) parts.push({ kind: "text", text: text.slice(last) });
  return parts;
}
